<template>
  <div class="overflow-auto h-full">
    <div class="bg-white align-top mb-4 rounded-lg p-4 inline-block mr-4" >
      <span class="text-xl font-bold border-b-2 border-primary block mb-4">Schnellsuche</span>
      <div class="">
        <label class="block text-sm font-medium text-gray-700 mb-1">Verträge</label>
        <input type="text" class=" inline-block w-36 p-2 mr-2 border-2 border-gray-200" placeholder="Freitext oder ID" v-model="searchContract" @keyup.enter="searchContract != '' ? searchContracts() : ''"/>
        <button v-if="searchContract" class=" inline-block w-32 align-middle mx-2 " @click="searchContracts()">Suche</button>
      </div>
      <div class="mt-2">
        <label class="block text-sm font-medium text-gray-700 mb-1">Kunden</label>
        <input type="text" class=" inline-block w-36 p-2 mr-2 border-2 border-gray-200" placeholder="Freitext oder ID" v-model="searchCustomer" @keyup.enter="searchCustomer != '' ? searchCustomers() : ''"/>
        <button v-if="searchCustomer" class=" inline-block w-32 align-middle mx-2 " @click="searchCustomers()">Suche</button>
      </div>
    </div>
    
    <div class="bg-white align-top mb-4 rounded-lg p-4 inline-block mr-4" v-if="stats.contracts">
      <span class="text-xl font-bold border-b-2 border-primary block mb-4">Vertragsmanagement</span>
      <table class="w-full">
        <thead>
          <tr class="border-b border-primary">
            <th class="text-left">Kategorie</th>
            <th>Anzahl</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><span class="font-bold">Verwaltete Verträge</span></td>
            <td class="text-right">{{ stats.contracts.all }}</td>
          </tr>
          <tr>
            <td><span class="font-bold">Aktive Verträge</span></td>
            <td class="text-right">{{ stats.contracts.active }}</td>
          </tr>
          <tr class="cursor-pointer" @click="$router.push({ path: '/contracts', query: { Status: 'Eingegangen' } })">
            <td><span class="font-bold">Eingegangene Verträge</span></td>
            <td class="text-right">{{ stats.contracts.new }}</td>
          </tr>
          <tr class="cursor-pointer" @click="$router.push({ path: '/contracts', query: { Status: 'Kündigung eingegangen' } })">
            <td><span class="font-bold">Eingegangene Kündigungen</span></td>
            <td class="text-right">{{ stats.contracts.cancellations }}</td>
          </tr>
          <tr class="cursor-pointer" @click="$router.push({ path: '/contracts', query: { Status: 'Warteliste' } })">
            <td><span class="font-bold">Verträge auf Warteliste</span></td>
            <td class="text-right">{{ stats.contracts.waitlist }}</td>
          </tr>
          <tr class="cursor-pointer" @click="$router.push({ path: '/contracts', query: { Status: 'Vorgemerkt' } })">
            <td><span class="font-bold">Vorgemerkte Verträge</span></td>
            <td class="text-right">{{ stats.contracts.reserved }}</td>
          </tr>
          <tr>
            <td><span class="font-bold">Ausgelaufene Verträge</span></td>
            <td class="text-right">{{ stats.contracts.expired }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="bg-white align-top mb-4 rounded-lg p-4 inline-block mr-4" v-if="stats.projects">
      <span class="text-xl font-bold border-b-2 border-primary block mb-4">Projekte</span>
      <table class="w-full">
        <thead>
          <tr class="border-b border-primary">
            <th class="text-left">Kategorie</th>
            <th>Anzahl</th>
          </tr>

        </thead>
        <tbody>
          <tr>
            <td><span class="font-bold">Alle Projekte</span></td>
            <td class="text-right">{{ stats.projects.all }}</td>
          </tr>
          <tr class="cursor-pointer" @click="$router.push({ path: '/projects', query: { Archiviert: 'False' } })">
            <td><span class="font-bold">Aktive Projekte</span></td>
            <td class="text-right">{{ stats.projects.active }}</td>
          </tr>
          <tr class="cursor-pointer" @click="$router.push({ path: '/projects', query: { Buchbar: 'True' } })">
            <td><span class="font-bold">Buchbare Projekte</span></td>
            <td class="text-right">{{ stats.projects.bookable }}</td>
          </tr>
          <tr class="cursor-pointer" @click="$router.push({ path: '/projects', query: { NurVormerkungen: 'True' } })">
            <td><span class="font-bold">Projekte zur Vormerkung</span></td>
            <td class="text-right">{{ stats.projects.prepared }}</td>
          </tr>
          <tr class="cursor-pointer" @click="$router.push({ path: '/projects', query: { Archiviert: 'True' } })">
            <td><span class="font-bold">Archivierte Projekte</span></td>
            <td class="text-right">{{ stats.projects.archived }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="bg-white align-top mb-4 rounded-lg p-4 inline-block mr-4" v-if="stats.announcements">
      <span class="text-xl font-bold border-b-2 border-primary block mb-4">Ankündigungen</span>
      <ul>
        <li v-for="announcement in stats.announcements" :key="announcement" class="text-lg font-bold cursor-pointer" @click="window.top.location.href=be_base+'/intern/announcements/'">{{ announcement }}</li>
      </ul>
    </div>

    <div class="bg-white align-top mb-4 rounded-lg p-4 inline-block mr-4" v-if="stats.meals">
      <span class="text-xl font-bold border-b-2 border-primary block mb-4">Mensa-Betrieb</span>
      <table class="w-full">
        <thead>
          <tr class="border-b border-primary">
            <th class="text-left">Typ</th>
            <th>Anzahl</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-left font-bold">Buchungen</td>
            <td class="text-right">{{ stats.meals.booked }}</td>
          </tr>
          <tr>
            <td class="text-left font-bold">Essen explizit ausgewählt</td>
            <td class="text-right">{{ stats.meals.chosen }}</td>
          </tr>
          <tr>
            <td class="text-left font-bold">Abholungen</td>
            <td class="text-right">{{ stats.meals.pickups }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="bg-white align-top mb-4 rounded-lg p-4 inline-block mr-4" v-if="stats.projectsoverview">
      <span class="text-xl font-bold border-b-2 border-primary block mb-4">Projektübersicht</span>
      <table class="w-full overflow-auto max-h-[400px] inline-block">
        <thead>
          <tr class="border-b border-primary" >
            <th class="text-left pr-4">Projekt</th>
            <th class="text-center">Bestätigt</th>
            <th class="text-center">Ausgelaufen</th>
            <th class="text-center">Warteliste</th>
            <th class="text-center">Eingegangen</th>
            <th class="text-center">Kündigung eingegangen</th>
            <th class="text-center">Gekündigt</th>
            <th class="text-center">Absage</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(project, index) in stats.projectsoverview" :key="project.title" @click="$router.push('/projects/' + project.id)" class="cursor-pointer" :class="{'bg-gray-100': index % 2 === 0}">
            <td class="font-bold pr-4">{{ project.Titel }}</td>
            <td class="text-center">{{ project['Bestätigt'] }}</td>
            <td class="text-center">{{ project['Ausgelaufen'] }}</td>
            <td class="text-center">{{ project['Warteliste'] }}</td>
            <td class="text-center">{{ project['Eingegangen'] }}</td>
            <td class="text-center">{{ project['Kündigung eingegangen'] }}</td>
            <td class="text-center">{{ project['Gekündigt'] }}</td>
            <td class="text-center">{{ project['Absage'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
  // @ is an alias to /src
  import API from "@/API";
  export default {
    name: "Cards",
    props: ["user"],
    data() {
      return {
        searchContract: "",
        searchCustomer: "",
        stats: {
          contracts: null,
          projects: null,
          projectsoverview: null,
          announcements: null,
          meals: null,
        },
        be_base: process.env.VUE_APP_BE_BASE,
        window: window
      };
    },
    methods: {
      searchContracts() {
        const contractId = parseInt(this.searchContract);
        if (!isNaN(contractId) && contractId.toString() === this.searchContract) {
          this.$router.push('/contracts/' + contractId);
        } else {
          this.$router.push({ path: '/contracts', query: { search: this.searchContract } });
        }
      },
      searchCustomers() {
        const customerId = parseInt(this.searchCustomer);
        if (!isNaN(customerId) && customerId.toString() === this.searchCustomer) {
          this.$router.push('/customers/' + customerId);
        } else {
          this.$router.push({ path: '/customers', query: { search: this.searchCustomer } });
        }
      },
      getContractsStats() {
        API.getContractsStats((r, status) => {
          if (status === 200) {
            this.stats.contracts = r;
          }
        });
      },
      getProjectsStats() {
        API.getProjectsStats((r, status) => {
          if (status === 200) {
            this.stats.projects = r;
          }
        });
      },
      getProjectsOverview() {
        API.getProjectsOverview((r, status) => {
          if (status === 200) {
            this.stats.projectsoverview = r;
          }
        });
      },
      getAnnouncements() {
        API.getDashboardAnnouncements((r, status) => {
          if (status === 200) {
            this.stats.announcements = r;
          }
        });
      },
      getMealsStats() {
        API.getMealsStats((r, status) => {
          if (status === 200) {
            this.stats.meals = r;
          }
        });
      },
      loadAllStats() {
        this.getContractsStats();
        this.getProjectsStats();
        this.getProjectsOverview();
        this.getAnnouncements();
        this.getMealsStats();
      },
    },
    mounted() {
      this.loadAllStats();
    },
  };
</script>